<template>
  <div class="news-list-container">
    <div class="main-container">
      <div class="page-header">
        <h1 class="page-title">{{ t("news.title") }}</h1>
      </div>

      <div class="news-grid">
        <div v-for="(item, index) in newsItems" :key="index" class="news-card">
          <!-- 图片区域 - 可点击跳转 -->
          <router-link :to="`/news/${item.id}`" class="news-image-link">
            <div class="news-image-wrapper">
              <img v-if="item.image" :src="item.image" :alt="item.title" class="news-image" />
              <div v-else class="news-image-placeholder" aria-hidden="true">图片待补充</div>
            </div>
          </router-link>

          <div class="news-content">
            <!-- 上方内容区域 - 时间和标题 -->
            <div class="news-content-top">
              <div class="news-date">{{ item.date }}</div>
              
              <!-- 标题 - 可点击跳转 -->
              <router-link :to="`/news/${item.id}`" class="news-title-link">
                <h2 class="news-title">{{ item.title }}</h2>
              </router-link>
              
              <p class="news-summary">{{ item.summary }}</p>
            </div>

            <!-- 底部内容区域 - 了解详情按钮 -->
            <div class="news-content-bottom">
              <!-- 了解详情按钮 -->
              <router-link :to="`/news/${item.id}`" class="read-more-link">
                <span>{{ t("home.newslist.readmore") }}</span>
                <div class="arrow-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 8.66671L16.3333 12L13 15.3334"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.3334 12L7.66675 12"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <button
          class="page-button"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <svg
            class="pagination-arrow left-arrow"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 19L8 12L15 5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>

        <span class="page-info"> {{ currentPage }} / {{ totalPages }} </span>

        <button
          class="page-button"
          :disabled="currentPage === totalPages"
          @click="nextPage"
        >
          <svg
            class="pagination-arrow right-arrow"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 5L16 12L9 19"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import img4 from "../assets/image/home/tdb.webp";
import img5 from "../assets/image/home/sweetprotein_102.jpg";
const { t, locale } = useI18n();
const router = useRouter();
const getImageByLang = (cnImage, enImage) => {
  return locale.value === 'en' ? enImage : cnImage;
};
// 模拟新闻数据
const allNewsItems = computed(() => [
  {
    id: '016',
    date: '2026-11-03',
    title: t('home.newslist.list.item16.title'),
    summary: t('home.newslist.list.item16.description'),
    image: 'https://www.healthcode.com/media/20261103/P2.jpg',
  },
  {
    id: '014',
    date: '2026-11-02',
    title: t('home.newslist.list.item14.title'),
    summary: t('home.newslist.list.item14.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/20261102/P5-1.png',
      'https://www.healthcode.com/media/20261102/en/P5-1.png'
    ),
  },
  {
    id: '015',
    date: '2026-10-29',
    title: t('home.newslist.list.item15.title'),
    summary: t('home.newslist.list.item15.description'),
    image: 'https://www.healthcode.com/media/20261029/P2.jpg',
  },
  {
    id: '012',
    date: '2026-10-26',
    title: t('home.newslist.list.item12.title'),
    summary: t('home.newslist.list.item12.description'),
    image: 'https://www.healthcode.com/media/pruoto1026/1.png',
  },
  {
    id: '013',
    date: '2026-10-22',
    title: t('home.newslist.list.item13.title'),
    summary: t('home.newslist.list.item13.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/Ampitor35/P1.png',
      'https://www.healthcode.com/media/Ampitor35/en/P1.png'
    ),
  },
  {
    id: '011',
    date: '2026-10-22',
    title: t('home.newslist.list.item11.title'),
    summary: t('home.newslist.list.item11.description'),
    image: 'https://www.healthcode.com/media/d2pi2.0/d2pi2.0-6.png',
  },
  {
    id: '10',
    date: '2026-10-16',
    title: t('home.newslist.list.item10.title'),
    summary: t('home.newslist.list.item10.description'),
    image: 'https://www.healthcode.com/media/CIIF2026/CIIF2026-1.jpg',
  },
  {
    id: '009',
    date: '2026-08-19',
    title: t('home.newslist.list.item9.title'),
    summary: t('home.newslist.list.item9.description'),
    image: 'https://www.healthcode.com/media/news/0819/1.jpg',
  },
  {
    id: '001',
    date: '2026-05-09',
    title: t('home.newslist.list.item8.title'),
    summary: t('home.newslist.list.item8.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/news/260509/cab-18.png',
      'https://www.healthcode.com/media/news/260509/cba-18EN.png'
    ),
  },
  {
    id: '002',
    date: '2026-04-16',
    title: t('home.newslist.list.item7.title'),
    summary: t('home.newslist.list.item7.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/news/260427/4.webp',
      'https://www.healthcode.com/media/news/260427/4.webp'
    ),
  },
  {
    id: '003',
    date: '2026-03-26',
    title: t('home.newslist.list.item6.title'),
    summary: t('home.newslist.list.item6.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/news/haiqia/OIF2026.jpg',
      'https://www.healthcode.com/media/news/haiqia/OIF2026_EN.jpg'
    ),
  },
  {
    id: '004',
    date: '2026-01-26',
    title: t('home.newslist.list.item5.title'),
    summary: t('home.newslist.list.item5.description'),
    image: img5,
  },
  {
    id: '005',
    date: "2025-11-15",
    title: t("home.newslist.list.item4.title"),
    summary: t("home.newslist.list.item4.description"),
    image: img4,
  },
  {
    id: '006',
    date: "2025-09-24",
    title: t("home.newslist.list.item1.title"),
    summary: t("home.newslist.list.item1.description"),
    image: "https://a.storyblok.com/f/287055582545350/1600x1066/c91da93edd/ciif-award.jpg/m/filters:format(webp):quality(85)",
  },
  {
    id: '007',
    date: "2025-07-22",
    title: t("home.newslist.list.item2.title"),
    summary: t("home.newslist.list.item2.description"),
    image: "https://a.storyblok.com/f/287055582545350/650x563/ecfa8946a1/bb957555d42c885d8cc4be94a5ab6adb48dc5500_size342_w650_h563.webp/m/filters:format(webp):quality(85)",
  },
  {
    id: '008',
    date: "2025-06-01",
    title: t("home.newslist.list.item3.title"),
    summary: t("home.newslist.list.item3.description"),
    image: "https://a.storyblok.com/f/287055582545350/1748x1280/0a742a2eac/kangma-factory.jpg/m/filters:format(webp):quality(85)",
  },
]);

// 分页相关
const currentPage = ref(1);
const itemsPerPage = 8;

const totalPages = computed(() => {
  return Math.ceil(allNewsItems.value.length / itemsPerPage);
});

const newsItems = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return allNewsItems.value.slice(start, end);
});

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};
</script>

<style scoped>
.news-list-container {
  background: #fff;
  width: 100%;
  margin: 0 auto;
  padding: 10rem 0 4rem 0;
}

.page-header {
  text-align: left;
  margin-bottom: 3rem;
  border-bottom: 1px solid rgb(233, 236, 239);
  padding-bottom: 1rem;
  margin-top: 4rem;
}

.page-title {
  font-size: 2.4rem;
  font-weight: 400;
  color: #333;
  margin: 0;
}

.news-grid {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin-bottom: 3rem;
}

.news-card {
  display: flex;
  gap: 4rem;
  align-items: stretch;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-bottom: 1px solid rgb(233, 236, 239);
  padding-bottom: 2rem;
}

.news-card:hover {
  transform: translateY(-5px);
}

/* 图片链接区域 - 可点击 */
.news-image-link {
  flex: 1;
  display: block;
  text-decoration: none;
  color: inherit;
}

.news-image-wrapper {
  border-radius: 0.8rem;
  overflow: hidden;
  aspect-ratio: 16/9;
  cursor: pointer;
  transition: all 0.3s ease;
}

.news-card:hover .news-image-wrapper {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.news-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-image-placeholder {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  background: #f0f3f3;
  color: #718080;
  font-size: 1.4rem;
}

.news-card:hover .news-image {
  transform: scale(1.05);
}

/* 内容区域 - 使用 flex 布局实现上下对齐 */
.news-content {
  flex: 1;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
}

/* 上方内容区域 - 时间和标题 */
.news-content-top {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* 底部内容区域 - 了解详情按钮 */
.news-content-bottom {
  margin-top: auto;
  padding-top: 1.5rem;
}

/* 标题链接区域 - 可点击 */
.news-title-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.news-title-link:hover .news-title {
  color: #000;
  opacity: 0.85;
}

.news-date {
  font-size: 1.4rem;
  color: #999;
  margin-bottom: 0.5rem;
}

.news-title {
  font-size: 1.8em;
  font-weight: 500;
  color: #333;
  margin: 0.5rem 0;
  line-height: 1.3;
  transition: color 0.3s ease;
  cursor: pointer;
}

.news-summary {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.6;
  margin: 1rem 0 0 0;
}

.read-more-link {
  display: inline-flex;
  align-items: center;
  color: #000;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.read-more-link:hover {
  color: #333;
  opacity: 0.8;
}

.arrow-icon {
  background: #ddd;
  border-radius: 50%;
  height: 1.5rem;
  width: 1.5rem;
  margin-left: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 3rem;
}

.page-button {
  background: #000;
  color: white;
  border: none;
  border-radius: 2.4rem;
  padding: 0.8rem 2rem;
  font-size: 1.4rem;
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  padding: 0;
}

.page-button:hover:not(:disabled) {
  background: #333;
}

.page-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.page-button:disabled .pagination-arrow {
  opacity: 0.5;
}

.pagination-arrow {
  width: 2rem;
  height: 2rem;
  color: white;
}

.page-info {
  font-size: 1.6rem;
  color: #666;
  min-width: 8rem;
  text-align: center;
}

@media (max-width: 1024px) {
  .news-card {
    padding: 2rem;
  }

  .news-title {
    font-size: 2rem;
  }

  .news-summary {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  .news-list-container {
    padding: 5rem 0;
  }

  .page-title {
    font-size: 2rem;
  }

  .news-grid {
    gap: 3rem;
  }

  .news-card {
    flex-direction: column !important;
    padding: 2rem;
  }

  .news-card.reverse {
    flex-direction: column !important;
  }

  .news-image-link {
    width: 100%;
  }

  .news-image-wrapper {
    width: 100%;
  }

  .news-content {
    padding: 1.5rem 0 0 0;
    width: 100%;
    min-height: auto;
  }

  .news-title {
    font-size: 1.8rem;
  }

  .news-summary {
    font-size: 1.4rem;
  }

  .pagination {
    gap: 1rem;
  }

  .page-button {
    padding: 0.6rem 1.5rem;
    font-size: 1.2rem;
  }

  .page-info {
    font-size: 1.4rem;
  }
}

@media (max-width: 480px) {
  .news-card {
    padding: 1.5rem;
  }

  .news-title {
    font-size: 1.6rem;
  }

  .news-summary {
    font-size: 1.3rem;
  }

  .read-more-link {
    font-size: 1.4rem;
  }
  
  .page-button {
    width: 3.5rem;
    height: 3.5rem;
  }
  
  .pagination-arrow {
    width: 1.8rem;
    height: 1.8rem;
  }
}
</style>